import { Dayjs } from 'dayjs';
import { DataModel } from '../../dto/dto.js';
import { OnlineTransactionDetails } from '../online-transaction-details.js';
import { ElectronicDeliveryMethod } from '../electronic-delivery-method.js';
import { BusinessModuleRef } from '../business-module-ref.js';
import { Refund } from '../discounts/refund.js';
import { OfflineTransactionDetails } from '../offline-transaction-details.js';
import { InvoiceVat } from '../invoicing/invoice-vat.js';
import { Price } from '../price.js';

export enum GenericOrderEntryStatus {
  Open = 'OPEN',
  Aborted = 'ABORTED',
  Canceled = 'CANCELED',
  Refunded = 'REFUNDED',
}

export abstract class GenericOrderEntry extends DataModel {
  public abstract get $typeName(): string;

  public abstract get businessRef(): BusinessModuleRef;
  public abstract get creatorId(): string;
  public abstract get uniqueId(): string;
  public abstract get orderId(): string;
  public abstract get creationDate(): Dayjs;
  public abstract get entryGroupId(): string | null;
  public abstract get note(): string | null;
  public abstract get status(): GenericOrderEntryStatus;
  public abstract get onlineTransactionDetails(): OnlineTransactionDetails | null;
  public abstract get offlineTransactionDetails(): OfflineTransactionDetails | null;
  public abstract get cancelledDate(): Dayjs | null;
  public abstract get cancelledBy(): string | null;
  public abstract get deliveryMethod(): ElectronicDeliveryMethod;

  abstract tryGetApplicationFee(): Price | null;
  abstract tryGetApplicationFeeVat(): InvoiceVat | null;

  abstract tryGetRefunds(): Refund[] | null;
  abstract tryAddRefund(refund: Refund): boolean;

  abstract copyAsAborted(): this;
  abstract copyAsCanceled(cancelledBy: string | null, cancelledDate: Dayjs, isRefund: boolean): this;

  abstract tryGetEventId(): string | null;
  abstract copyWithOnlineTransactionDetails(transactionDetails: OnlineTransactionDetails): this;
  abstract copyWithOfflineTransactionDetails(transactionDetails: OfflineTransactionDetails): this;
}
